import React from 'react';
import { useTranslation } from 'react-i18next';

import mobileWorkExample from '../../assets/img/mobile-work-example.png';
import licenseBuyGpsrSeeHowItWorksImg from '../../assets/img/license-buy-gpsr-see-how-it-works-img.png';
import licenseBuyGpsrSeeHowItWorks2Img from '../../assets/img/license-buy-gpsr-see-how-it-works2-img.png';
import googleReviewManagerWorkExample from '../../assets/img/license-buy-google-review-manager-work-example.png';

interface WorkExampleProps {
  licenseType: string;
  className?: string;
}

const WorkExample: React.FC<WorkExampleProps> = ({ licenseType, className = '' }) => {
  const { t } = useTranslation();

  const getContent = () => {
    switch (licenseType) {
      case 'freshdesk':
        return (
          <div className="work-example-youtube">
            <div className="youtube-video">
              <iframe
                src="https://www.youtube.com/embed/uyZMjHllVn8"
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        );
      case 'content_master':
        return <div></div>;
      case 'gpsr':
        return <div className="gpsr-example-images">
          <img src={licenseBuyGpsrSeeHowItWorksImg} alt="GPSR" />
          <img src={licenseBuyGpsrSeeHowItWorks2Img} alt="GPSR" />
        </div>;
      case 'mobile':
        return <div className="mobile-example-images">
          <img src={mobileWorkExample} alt="Mobile" />
        </div>;
      case 'google_review_manager':
        return <div className="mobile-example-images">
          <img src={googleReviewManagerWorkExample} alt="Google Review Manager" />
        </div>;
      default:
        return <div></div>;
    }
  };

  return (
    <div className={`work-example ${className}`}>
      <div className="work-example-container">
        <h2 className="block-title">{t('see_how_it_works_section.title')}</h2>
        <div className="work-example-content">
          {getContent()}
        </div>
      </div>
    </div>
  );
};

export default WorkExample;
